import React, { memo, useCallback } from 'react';

import { ThreeDStockProductsCompactListItemProduct } from './ThreeDStockProductsCompactListItem.types';
import {
  ChangeProductsFiltersFunc,
  FetchProductsFilters,
  OnProductSimilarSearchAction,
  ProductNanoID,
  UpdateProductCacheAction
} from '../../../../products/productsTypes';
import { OnLightboxOpenAction } from '../../../../../helpers/LightboxWrapper';

import { ThreeDStockProductsCompactListItemPreview } from './components/ThreeDStockProductsCompactListItemPreview';
import { ThreeDStockProductsCompactListItemInfo } from './components/ThreeDStockProductsCompactListItemInfo';
import { ThreeDStockProductsCompactListItemButtons } from './components/ThreeDStockProductsCompactListItemButtons';

type ThreeDStockProductsCompactListItemProps = {
  product: ThreeDStockProductsCompactListItemProduct;
  onProductEditButtonMouseEnter?: (productNanoId: ProductNanoID) => void;
  onLightboxOpen: OnLightboxOpenAction;
  updateProductCache?: UpdateProductCacheAction<ThreeDStockProductsCompactListItemProduct>;
  onProductSimilarSearchFilter?: OnProductSimilarSearchAction;
  changeProductsFilters: ChangeProductsFiltersFunc;
  productsFilters: FetchProductsFilters;
  downloadButtonAction: string;
  downloadSeparatelyButtonAction: string;
  findSimilarButtonAction: string;
  editButtonAction: string;
};

function ThreeDStockProductsCompactListItem({
  product,
  onProductEditButtonMouseEnter,
  onLightboxOpen,
  onProductSimilarSearchFilter,
  updateProductCache,
  changeProductsFilters,
  productsFilters,
  downloadButtonAction,
  downloadSeparatelyButtonAction,
  findSimilarButtonAction,
  editButtonAction
}: ThreeDStockProductsCompactListItemProps) {
  const handleOpenLightbox = useCallback(() => {
    if (product.image) {
      onLightboxOpen(product);
    }
  }, [product, onLightboxOpen]);

  const handleEditButtonMouseEnter = useCallback<() => void>(() => {
    onProductEditButtonMouseEnter(product.nanoId);
  }, [onProductEditButtonMouseEnter, product.nanoId]);

  return (
    <div className="group rounded-xl relative has-[:checked]:ring has-[:checked]:bg-blue-500/20 has-[:checked]:hover:bg-blue-500/20 dark:has-[:checked]:hover:bg-blue-500/20 hover:bg-gray-100 dark:hover:bg-gray-850 flex gap-4 items-center p-2 max-w-full transition-colors duration-150 ease-out">
      <ThreeDStockProductsCompactListItemPreview
        product={product}
        onLightboxOpen={handleOpenLightbox}
      />

      <ThreeDStockProductsCompactListItemInfo
        product={product}
        changeProductsFilters={changeProductsFilters}
        productsFilters={productsFilters}
      />

      <ThreeDStockProductsCompactListItemButtons
        product={product}
        updateProductCache={updateProductCache}
        onEditButtonMouseEnter={handleEditButtonMouseEnter}
        onProductSimilarSearchFilter={onProductSimilarSearchFilter}
        downloadButtonAction={downloadButtonAction}
        downloadSeparatelyButtonAction={downloadSeparatelyButtonAction}
        findSimilarButtonAction={findSimilarButtonAction}
        editButtonAction={editButtonAction}
      />
    </div>
  );
}

export default memo<ThreeDStockProductsCompactListItemProps>(
  ThreeDStockProductsCompactListItem
);
